import { BrowserRouterRender } from 'Modules/core/react';

import {
    InitializeRender,
    LandingRender,
    MuiThemeProviderRender,
    RedirectToHome,
    TrackerRender,
} from './middlewares';
// @ts-ignore
import translations from './translations.json';
import { state } from './state';
import { descisions, monitoring, news, withUs } from './api';
import { ContactsModal } from './components/ContactsModal';
import { PersonalDataModal } from './components/PersonalDataModal';
import { FeedbackModal } from './components/FeedbackModal';
import './index.scss';


export const landingDfa = {
    API: {
        domain: {
            descisions,
            news,
            withUs,
            monitoring,
        },
    },

    messaging: {
        modalTypes: {
            ContactsModal,
            FeedbackModal,
            PersonalDataModal,
        },
    },

    data: {
        domain: {
            descisions: {},
            news: {},
            withUs: {},
            monitoring: {},
        },
    },

    renderChain: [
        [MuiThemeProviderRender, 45],
        [BrowserRouterRender, -30],
        [TrackerRender, -31],
        [InitializeRender, -35],
        [LandingRender, -50],
        [RedirectToHome, -60],
    ],

    state,

    translations,
};
